import { graphql } from "@/data-access/graphql";

const ScheduledBriefingLogoFragment = graphql(`
  fragment ScheduledBriefingLogoFragment on DjangoImageType @_unmask {
    url
    name
  }
`);

export const ScheduledBriefingFragment = graphql(
  `
  fragment ScheduledBriefingFragment on ScheduledBriefingType @_unmask {
    __typename
    id
    name
    description
    prompt
    hasUserPrompt
    recipients
    scheduleType
    sendAt
    sendOn
    timezone
    isActive
    logoUrl
    logo {
      ...ScheduledBriefingLogoFragment
    }
    updatedAt
    createdBy {
      id
      name
    }
  }
  `,
  [ScheduledBriefingLogoFragment],
);
